import React, { useState } from 'react'
import Box from '../../../../../components/box/box'
import ReactModal from 'react-modal'
import message from '../../../../../teach/components/message/message'
import QRcode from 'qrcode.react'
import * as api from '../../../../../teach/api/share'
import styles from './styles.scss'
import modalStyles from '../../../../../components/browser-modal/browser-modal.css'
import customStyles from '../../../../../teach/components/confirm-modal/confirm-modal.css'

const coverImg = 'https://oss.pkcode.cn/scratch/thumb/'

const EditShareModal = ({ onClose, isPlayerOnly, projectInfo, desc, oi, keyboard, changeStage, isPhone }) => {

    const keyboards = [
        { id: 0, cover: '' },
        { id: 1, cover: require('./images/键盘1.png') },
        { id: 2, cover: require('./images/键盘2.png') },
        { id: 3, cover: require('./images/键盘3.png') },
        { id: 4, cover: require('./images/键盘4.png') }
    ]

    const [infos, setInfos] = useState(projectInfo || null)
    const [selected, setSelected] = useState(keyboard || 0)
    const [currentKey, setCurrentKey] = useState(keyboards[selected])
    const [editDesc, setEditDesc] = useState(desc || '')
    const [editOi, setEditOi] = useState(oi || '')
    const [shareQR, setShareQR] = useState(false)

    const handleKeyboardSelected = (index = 0) => {
        setSelected(index)
        setCurrentKey(keyboards[index])
    }

    // 分享
    const handleShare = async () => {
        if (!editDesc) {
            message.show('请输入作品介绍!')
            return
        }

        if (!editOi) {
            message.show('请输入操作说明!')
            return
        }

        const params = {
            id: infos.id,
            desc: editDesc, // 作品介绍
            oi: editOi, // 操作说明
            keyboard: currentKey.id, // 键盘类型<Array>
            is_public: 1
        }
        const res = await api.shareSave(params)
        if (!!res) {
            if (!isPlayerOnly) {
                setShareQR(!shareQR)
            } else {
                const copyInfo = JSON.parse(JSON.stringify(projectInfo))
                copyInfo.desc = editDesc
                copyInfo.oi = editOi
                copyInfo.keyboard = currentKey.id
                onClose({
                    desc: editDesc,
                    oi: editOi,
                    keyboard: currentKey.id
                })
                message.show('修改成功!')
            }
        }
    }

    const handleClick = () => {
        location.href =`${location.href}?type=share`
    }

    return (
        <ReactModal
            className={`${styles.modalContent} ${customStyles.madalBox}`}
            overlayClassName={`${modalStyles.modalOverlay} ${customStyles.bgOpactiy}`}
            isOpen={true}
            closeTimeoutMS={400}
        >
            <Box className={`${styles.boxTop} ${modalStyles.illustration} ${modalStyles.title}`}>
                <div style={{ width: 60, height: 60, backgroundColor: 'transparent' }}></div>
                <span>{shareQR ? '' : '完善作品信息'}</span>
                <a onClick={onClose}>
                    <img src={require('../../../../../teach/components/confirm-modal/poopup_btn_icon_close.png')} />
                    <span>关闭</span>
                </a>
            </Box>
            {
                shareQR ? (
                    <div className={styles.shareContainer}>
                        <h3>分享成功</h3>
                        {
                            !isPhone && <div>
                                <QRcode style={{ width: 160, height: 160 }} value={`${location.origin}/teacher/mobile-share?id=${infos.id}`}></QRcode>
                                <div className={styles.popNotice}>
                                    <div className={styles.triangle}></div>
                                    <div className={styles.notice}>
                                        <span>微信扫码分享</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <button onClick={() => {
                            onClose()
                            handleClick()
                        }} className={styles.shareBtn}>查看分享结果</button>
                    </div>
                ) : (
                    <div className={styles.container}>
                        <div className={styles.worksArea}>
                            <div className={styles.coverArea}>
                                <span className={styles.areaTitle}>封面图</span>
                                <div className={styles.cover}>
                                    <img src={!!infos ? coverImg + infos.id + '.png' : ''} alt='' />
                                </div>
                                <div className={styles.name}>
                                    <span>{!!infos ? infos.title : ''}</span>
                                </div>
                            </div>
                            <div className={styles.infoArea}>
                                <div className={styles.info}>
                                    <span className={styles.areaTitle}>作品介绍</span>
                                    <textarea placeholder='介绍一下你的作品' value={editDesc} onChange={e => setEditDesc(e.target.value)} />
                                </div>
                                <div className={styles.info}>
                                    <span className={styles.areaTitle}>操作说明</span>
                                    <textarea placeholder='告诉大家如何操作' value={editOi} onChange={e => setEditOi(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className={styles.keyboard}>
                            <span className={styles.areaTitle}>虚拟键盘</span>
                            <div className={styles.cards}>
                                {
                                    keyboards.map((item, index) => (
                                        <div
                                            key={item.id}
                                            className={`${styles.cardItem} ${selected === index && styles.selected}`}
                                            onClick={() => handleKeyboardSelected(index)}
                                        >
                                            {
                                                !!item.cover
                                                    ? <img src={item.cover} alt='' style={{ width: '100%', height: '100%' }} />
                                                    : <span>不使用虚拟键盘</span>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            }
            {
                !shareQR &&
                <div className={styles.footer}>
                    {
                        !isPlayerOnly && <div style={{ display: 'flex', marginRight: 8, alignItems: 'center' }}>
                            <div className={styles.notice}>
                                <span>分享作品将在加入的班级中展示，接受点赞、评论和分享。</span>
                            </div>
                            <div className={styles.triangle}></div>
                        </div>
                    }
                    {
                        isPlayerOnly
                            ? <button onClick={handleShare} className={styles.shareBtn}>重新分享</button>
                            : <button onClick={handleShare} className={styles.shareBtn}>分享</button>
                    }
                </div>
            }
        </ReactModal>
    )
}

export default EditShareModal
